import React from "react"
import BlockContent from "@sanity/block-content-to-react"
import serializers from "../helpers/serialize"

const Content = ({ data, portfolioText }) => {
  return <BlockContent blocks={data} serializers={serializers} />
}
export default Content
